import { Injectable, Inject } from '@angular/core';
import { Actions, Effect } from '@ngrx/effects';
import * as message from '../actions/message.actions';

import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/delay';

/**
 * Effects related to application messages.
 */
@Injectable()
export class MessagesEffect {

    /**
     * Delete message after some delay.
     */
    @Effect() clearMessages$ = this.actions$.ofType(message.MESSAGE_SHOW)
        .delay(new Date(Date.now() + this.messagesDisplayTime))
        .map((action: message.MessageShowAction) => new message.MessageHideAction(action.payload.id));


    constructor(private actions$: Actions, @Inject('messagesDisplayTime') private messagesDisplayTime: number) {}

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/core/effects/messages.effect.ts